import { useCallback, useEffect } from 'react'
import { closeDrawer, isFormSubmitLoading, reportFormData, reportFormNumSearches, selectedReportTypeTab, setReportData } from 'Pages/ReportsAlerts/Reports/@signals'
import { postSubmit, formatDate, isEmpty } from '@ui-seeker/utils'
import { useToast } from '@hooks'
import { useReportBackendApiPath } from 'Pages/ReportsAlerts/Reports/@hooks/index'
import { parseBackendDate } from '@utils'

export default function useReportFormSubmit() {

	const { showToast } = useToast()
	const { backendUrl } = useReportBackendApiPath()

	const onFormSubmit = useCallback(() => {
		postSubmit(`${backendUrl}/${!reportFormData.value?.title?.includes('Edit:') ? 'create' : 'edit'}`, {
			...reportFormData.value,
			reportType: selectedReportTypeTab.value,
			specificDates: !!reportFormData.value.specificDates?.length ? reportFormData.value.specificDates.map(i => formatDate(parseBackendDate(i), { format: 'yyyy-MM-dd' })) : null,
			terminationDate: reportFormData.value.terminationDate ? formatDate(parseBackendDate(reportFormData.value.terminationDate), { format: 'yyyy-MM-dd' }) : null,
			executionDateMin: reportFormData.value.executionDateMin ? formatDate(parseBackendDate(reportFormData.value.executionDateMin), { format: 'yyyy-MM-dd' }): null,
			executionDateMax : reportFormData.value.executionDateMax ? formatDate(parseBackendDate(reportFormData.value.executionDateMax), { format: 'yyyy-MM-dd' }): null,
			numSearches: reportFormNumSearches.value,
		}).then(data => {
			setReportData(data)
			isFormSubmitLoading.value = false
			closeDrawer()
		}).catch(() => {
			isFormSubmitLoading.value = false
			showToast.error("Error creating report")
		})
	}, [])

	useEffect(() => {
		if (isFormSubmitLoading.value && !isEmpty(reportFormData.value)) onFormSubmit()
	}, [isFormSubmitLoading.value])

}